import { Component, Input, OnInit } from '@angular/core';
import { Trigger } from '../../../../model/trigger';
import { Event } from '../../../../model/event';
import { Asset } from '../../../../model/asset';
import { TriggerFilters } from '../../../../model/filters/trigger-filters';
import { EventFilters } from '../../../../model/filters/event-filters';
import { TriggersService } from '../../../../services/triggers.service';
import { Router } from '@angular/router';
import { EventsService } from '../../../../services/events.service';
import {TimezoneService} from '../../../../services/timezone.service';

@Component({
  selector: 'app-asset-events',
  templateUrl: './asset-events.component.html',
  styleUrls: ['./asset-events.component.scss']
})
export class AssetEventsComponent implements OnInit {

  @Input()
  public asset: Asset;

  @Input()
  public navState: any;

  public rangeDates: Date[];
  public triggers: Trigger[];
  public selectedTrigger: Trigger;

  public events: Event[];
  public totalEvents: number;
  public loadingEvents: boolean;

  public rows = 10;
  public first = 0;

  public currentTriggerFilters: TriggerFilters;
  public currentEventFilters: EventFilters;

  constructor(public triggersService: TriggersService,
              public router: Router,
              public eventsService: EventsService,
              private timezoneService: TimezoneService) {
    const last24h = new Date();
    last24h.setHours(last24h.getHours() - 24);
    this.rangeDates = [last24h, new Date()];
  }

  ngOnInit(): void {
    this.events = new Array(0);
    this.loadFilters();
    this.loadTriggers();
  }

  private loadTriggers(): void {
    this.triggersService.getTriggers(null, null, this.currentTriggerFilters)
      .toPromise().then(response => {
      this.triggers = response.triggers
        .sort((a, b) => a.name > b.name ? 1 : -1);
      if (this.navState && this.navState.trigger) {
        this.selectedTrigger = this.triggers.filter(trigger => {
          return trigger.name === this.navState.trigger.name && trigger.creationAt === this.navState.trigger.creationAt;
        })[0];
        this.loadEvents();
      } else {
        this.selectedTrigger = this.triggers[0];
      }
    });
  }

  private loadEvents(): void {
    this.loadingEvents = true;
    this.events = new Array(this.rows);

    const utcRange = this.timezoneService.timestampRangeFromCalendarData(this.rangeDates);

    this.eventsService.searchEvents(this.asset.tenant.uuid, this.asset.uuid, this.selectedTrigger.assetMeasurement.uuid,
      this.selectedTrigger.name, utcRange.from, utcRange.until)
      .subscribe(response => {
        this.events = response.events;
        this.totalEvents = this.events.length;
        this.loadingEvents = false;
      });
  }

  private loadFilters(): void {
    this.currentTriggerFilters = new TriggerFilters();
    this.currentTriggerFilters.entityType = 'ASSET';
    this.currentTriggerFilters.entityUuid = this.asset.uuid;

    this.currentEventFilters = new EventFilters();
    this.currentTriggerFilters.entityType = 'ASSET';
    this.currentTriggerFilters.entityUuid = this.asset.uuid;
  }

  searchEvents(): void {
    this.loadEvents();
  }

}
